import { Col } from "antd";
import React from "react";

type DrawerItemWrapperProps = {
  children: React.ReactNode;
  span?: number;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
};

export function DrawerItemWrapper(props: DrawerItemWrapperProps) {
  const { children, span = 12, xs = 24, sm = 24, md = 12, lg = 12 } = props;
  return (
    <Col span={span} xs={xs} sm={sm} md={md} lg={lg}>
      {children}
    </Col>
  );
}
